/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner } from './disable-user-usage-limit200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DisableUserUsageLimit200ResponseReissue } from './disable-user-usage-limit200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { DisableUserUsageLimit200ResponseUser } from './disable-user-usage-limit200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { DisableUserUsageLimit200ResponseUserAccountGroup } from './disable-user-usage-limit200-response-user-account-group';

/**
 * 
 * @export
 * @interface DisableUserUsageLimit200Response
 */
export interface DisableUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableUserUsageLimit200Response
     */
    'availableCurrencies': Array<DisableUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableUserUsageLimit200ResponseUser}
     * @memberof DisableUserUsageLimit200Response
     */
    'user': DisableUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {DisableUserUsageLimit200ResponseUserAccountGroup}
     * @memberof DisableUserUsageLimit200Response
     */
    'userAccountGroup'?: DisableUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {DisableUserUsageLimit200ResponseReissue}
     * @memberof DisableUserUsageLimit200Response
     */
    'reissue'?: DisableUserUsageLimit200ResponseReissue | null;
}

export const DisableUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof DisableUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof DisableUserUsageLimit200ResponseAvailableCurrenciesEnum];


